
import { Component, Vue, Prop } from 'vue-property-decorator';
import { GruppoVenduto } from '@/models';
import ItemListVenduto from "./ItemListVenduto.vue";

@Component({
    components: { ItemListVenduto }
})
export default class VendutoList extends Vue {
    @Prop() private venduto!: GruppoVenduto[];    
}
